<template>
  <div class="configuracion-correos py-4" :class="themeClass">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-xxl-9 col-xl-10">
          <div class="card shadow-sm border-0">
            <div class="card-header bg-gradient text-white d-flex justify-content-between align-items-center">
              <div>
                <h3 class="mb-0"><i class="bi bi-envelope me-2"></i>Configuración de Correo Electrónico</h3>
                <small class="text-white-50">Configura el servidor SMTP para el envío automático de documentos a tus clientes</small>
              </div>
              <span v-if="emailConfig.configurado" class="badge bg-success fw-semibold">
                <i class="bi bi-check-circle-fill me-1"></i>Configurado
              </span>
              <span v-else class="badge bg-warning text-dark fw-semibold">
                <i class="bi bi-exclamation-triangle-fill me-1"></i>Pendiente
              </span>
            </div>
            <div class="card-body">

              <div v-if="cargando" class="text-center py-5">
                <div class="spinner-border text-primary"></div>
                <p class="text-muted mt-3">Cargando configuración...</p>
              </div>

              <template v-else>
                <div v-if="mensajeError" class="alert alert-danger d-flex justify-content-between align-items-center">
                  <span>{{ mensajeError }}</span>
                  <button type="button" class="btn-close" @click="mensajeError = ''"></button>
                </div>
                <div v-if="mensajeExito" class="alert alert-success d-flex justify-content-between align-items-center">
                  <span>{{ mensajeExito }}</span>
                  <button type="button" class="btn-close" @click="mensajeExito = ''"></button>
                </div>

                <div class="row g-4">
                  <!-- Configuración SMTP -->
                  <div class="col-12">
                    <section class="section-card">
                      <header class="section-card__header">
                        <div>
                          <h5 class="mb-0">Correo de salida</h5>
                          <small class="text-muted">Elige si usas tu propio servidor SMTP o el correo por defecto del sistema</small>
                        </div>
                      </header>
                      <div class="section-card__body">

                        <!-- Selector activo/inactivo -->
                        <div class="d-flex align-items-center gap-3 p-3 rounded-3 mb-4"
                             :class="emailConfig.habilitado ? 'bg-success bg-opacity-10 border border-success border-opacity-25' : 'bg-secondary bg-opacity-10 border border-secondary border-opacity-25'">
                          <div class="form-check form-switch mb-0">
                            <input class="form-check-input" type="checkbox" id="enviohabilitado"
                                   v-model="emailConfig.habilitado" style="width:2.8em;height:1.5em;cursor:pointer">
                            <label class="form-check-label visually-hidden" for="enviohabilitado">Usar correo propio</label>
                          </div>
                          <div>
                            <strong :class="emailConfig.habilitado ? 'text-success' : ''">
                              <i :class="emailConfig.habilitado ? 'bi bi-envelope-check-fill' : 'bi bi-envelope-slash-fill'" class="me-1"></i>
                              {{ emailConfig.habilitado ? 'Correo propio activado' : 'Usando correo por defecto del sistema' }}
                            </strong>
                            <div class="small mt-1" :class="emailConfig.habilitado ? 'text-success' : 'text-muted'">
                              <template v-if="emailConfig.habilitado">
                                Los documentos se enviarán desde tu correo configurado abajo.
                              </template>
                              <template v-else>
                                Los documentos autorizados por el SRI se enviarán automáticamente desde
                                <strong>facturacion@sicecom.com</strong> con el nombre de tu empresa.
                                El <strong>XML autorizado</strong> y el <strong>RIDE</strong> van adjuntos.
                              </template>
                            </div>
                          </div>
                        </div>

                        <!-- Campos SMTP: solo visibles cuando está habilitado -->
                        <div v-if="emailConfig.habilitado" class="row g-3">
                          <div class="col-md-6">
                            <label class="form-label">Correo remitente *</label>
                            <input type="email" class="form-control" v-model.trim="emailConfig.correoRemitente"
                                   placeholder="facturacion@empresa.com" />
                            <small class="text-muted">Correo desde el que se enviarán los documentos</small>
                          </div>
                          <div class="col-md-6">
                            <label class="form-label">Contraseña</label>
                            <div class="input-group">
                              <input :type="mostrarClave ? 'text' : 'password'" class="form-control"
                                     v-model="emailConfig.clave"
                                     :placeholder="emailConfig.claveGuardada ? '••••••••• (guardada)' : 'Contraseña del correo'" />
                              <button class="btn btn-outline-secondary" type="button" @click="mostrarClave = !mostrarClave">
                                <i :class="mostrarClave ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                              </button>
                            </div>
                            <small class="text-muted" v-if="emailConfig.claveGuardada">
                              Deja vacío para mantener la contraseña actual
                            </small>
                          </div>
                          <div class="col-md-5">
                            <label class="form-label">Servidor SMTP *</label>
                            <input type="text" class="form-control" v-model.trim="emailConfig.servidorSmtp"
                                   placeholder="smtp.hostinger.com" />
                          </div>
                          <div class="col-md-3">
                            <label class="form-label">Puerto *</label>
                            <input type="number" class="form-control" v-model.number="emailConfig.puertoSmtp"
                                   placeholder="465" min="1" max="65535" />
                          </div>
                          <div class="col-md-4">
                            <label class="form-label">Encriptación</label>
                            <select class="form-select" v-model="emailConfig.encriptacion">
                              <option value="ssl">SSL (puerto 465)</option>
                              <option value="tls">TLS (puerto 587)</option>
                              <option value="none">Ninguna</option>
                            </select>
                          </div>
                        </div>

                      </div>
                    </section>

                    <!-- Opciones de envío -->
                    <section class="section-card mt-4">
                      <header class="section-card__header">
                        <div>
                          <h5 class="mb-0">Documentos a enviar</h5>
                          <small class="text-muted">Selecciona qué tipos de documentos se enviarán automáticamente</small>
                        </div>
                      </header>
                      <div class="section-card__body">
                        <div class="row g-3">
                          <div class="col-md-4">
                            <div class="form-check form-switch">
                              <input class="form-check-input" type="checkbox" id="envioFacturas" v-model="opciones.envioFacturas">
                              <label class="form-check-label" for="envioFacturas">Facturas electrónicas</label>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-check form-switch">
                              <input class="form-check-input" type="checkbox" id="envioNotasCredito" v-model="opciones.envioNotasCredito">
                              <label class="form-check-label" for="envioNotasCredito">Notas de crédito</label>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-check form-switch">
                              <input class="form-check-input" type="checkbox" id="envioGuias" v-model="opciones.envioGuias">
                              <label class="form-check-label" for="envioGuias">Guías de remisión</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <div class="d-flex gap-2 justify-content-end mt-3">
                      <button v-if="emailConfig.habilitado" class="btn btn-outline-secondary" @click="probarConexion" :disabled="probando">
                        <span v-if="probando" class="spinner-border spinner-border-sm me-1"></span>
                        <i v-else class="bi bi-send-check me-1"></i>
                        Probar conexión
                      </button>
                      <button class="btn btn-primary px-4" @click="guardar" :disabled="guardando">
                        <span v-if="guardando" class="spinner-border spinner-border-sm me-2"></span>
                        <i v-else class="bi bi-floppy me-1"></i>
                        Guardar
                      </button>
                    </div>
                  </div>

                  <!-- Panel de referencia -->
                  <!-- ...bloque eliminado por solicitud... -->
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import themeManager from '@/store/theme'
import api from '@/services/api'

export default {
  name: 'ClientConfiguracionCorreos',
  data() {
    return {
      cargando: true,
      guardando: false,
      probando: false,
      mostrarClave: false,
      mensajeError: '',
      mensajeExito: '',
      emailConfig: {
        correoRemitente: '',
        clave: '',
        claveGuardada: false,
        servidorSmtp: '',
        puertoSmtp: 465,
        encriptacion: 'ssl',
        habilitado: false,
        configurado: false
      },
      opciones: {
        envioFacturas: true,
        envioNotasCredito: true,
        envioGuias: false
      }
    }
  },
  computed: {
    themeClass() {
      return themeManager.themeClass
    }
  },
  created() {
    this.cargarDatos()
  },
  methods: {
    async cargarDatos() {
      this.cargando = true
      try {
        const res = await api.get('/configuracion/correo')
        const datos = res?.data?.data || res?.data || {}
        this.emailConfig.correoRemitente = datos.from_email    || datos.correo_remitente || ''
        this.emailConfig.servidorSmtp     = datos.smtp_host     || datos.servidor_smtp   || ''
        this.emailConfig.puertoSmtp       = datos.smtp_port     || datos.puerto_smtp     || 465
        this.emailConfig.encriptacion     = datos.encryption    || datos.encriptacion    || 'ssl'
        this.emailConfig.habilitado      = !!datos.is_enabled
        this.emailConfig.claveGuardada   = !!datos.password_hash
        this.emailConfig.configurado     = !!datos.is_configured
        if (datos.opciones_envio) {
          this.opciones.envioFacturas    = datos.opciones_envio.facturas   !== false
          this.opciones.envioNotasCredito = datos.opciones_envio.notas_credito !== false
          this.opciones.envioGuias       = !!datos.opciones_envio.guias_remision
        }
      } catch {
        // Primera configuración — valores por defecto están cargados
      } finally {
        this.cargando = false
      }
    },

    async guardar() {
      if (this.emailConfig.habilitado && (!this.emailConfig.correoRemitente || !this.emailConfig.servidorSmtp)) {
        this.mensajeError = 'El correo remitente y el servidor SMTP son obligatorios cuando el correo propio está activo.'
        return
      }
      this.guardando = true
      this.mensajeError = ''
      this.mensajeExito = ''
      try {
        const payload = {
          from_email:    this.emailConfig.correoRemitente,
          smtp_host:     this.emailConfig.servidorSmtp,
          smtp_port:     this.emailConfig.puertoSmtp,
          encryption:    this.emailConfig.encriptacion,
          is_enabled:    this.emailConfig.habilitado,
          opciones_envio: {
            facturas:       this.opciones.envioFacturas,
            notas_credito:  this.opciones.envioNotasCredito,
            guias_remision: this.opciones.envioGuias
          }
        }
        if (this.emailConfig.clave) {
          payload.password = this.emailConfig.clave
        }
        await api.post('/configuracion/correo', payload)
        this.mensajeExito = 'Configuración de correo guardada correctamente.'
        this.emailConfig.clave = ''
        this.emailConfig.configurado = true
        this.emailConfig.claveGuardada = true
      } catch (error) {
        this.mensajeError = error?.response?.data?.error || error?.message || 'No se pudo guardar la configuración de correo.'
      } finally {
        this.guardando = false
      }
    },

    async probarConexion() {
      if (!this.emailConfig.habilitado) {
        this.mensajeError = 'Activa el correo propio para poder probar la conexión SMTP.'
        return
      }
      if (!this.emailConfig.correoRemitente || !this.emailConfig.servidorSmtp) {
        this.mensajeError = 'Completa el correo y el servidor SMTP antes de probar la conexión.'
        return
      }
      this.probando = true
      this.mensajeError = ''
      this.mensajeExito = ''
      try {
        await api.post('/configuracion/correo/test', {
          from_email: this.emailConfig.correoRemitente,
          smtp_host:  this.emailConfig.servidorSmtp,
          smtp_port:  this.emailConfig.puertoSmtp,
          encryption: this.emailConfig.encriptacion
        })
        this.mensajeExito = 'Conexión SMTP verificada correctamente. El correo está listo para enviar.'
      } catch (error) {
        this.mensajeError = error?.response?.data?.error || 'No se pudo conectar al servidor SMTP. Revisa los datos e inténtalo de nuevo.'
      } finally {
        this.probando = false
      }
    }
  }
}
</script>

<style scoped>
.configuracion-correos {
  --primary-color: #1173d4;
  --body-bg: #f5f7fb;
  --card-bg: #ffffff;
  --border-color: rgba(17, 115, 212, 0.1);
  --text-primary: #1f2933;
  --text-secondary: #4a5568;
  background-color: var(--body-bg);
  min-height: 100vh;
  padding-bottom: 2rem;
}

.configuracion-correos.dark-theme {
  --body-bg: #0b1320;
  --card-bg: #111d30;
  --border-color: rgba(148, 163, 184, 0.18);
  --text-primary: #e2e8f0;
  --text-secondary: #cbd5f5;
}

.card {
  background-color: var(--card-bg);
  border-color: var(--border-color);
  color: var(--text-primary);
}

.bg-gradient {
  background: linear-gradient(135deg, rgba(17, 115, 212, 0.95) 0%, rgba(40, 137, 235, 0.9) 100%);
}

.section-card {
  border: 1px solid var(--border-color);
  border-radius: 18px;
  padding: 1.6rem;
  margin-bottom: 1.4rem;
  background-color: var(--card-bg);
  color: var(--text-primary);
  box-shadow: 0 10px 24px -18px rgba(15, 46, 70, 0.28);
}

.configuracion-correos.dark-theme .section-card {
  box-shadow: none;
}

.section-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.2rem;
}

.section-card__header h5 { font-weight: 700; }

.form-control,
.form-select {
  background-color: var(--card-bg);
  color: var(--text-primary);
  border-color: rgba(148, 163, 184, 0.4);
  border-radius: 10px;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(17, 115, 212, 0.15);
  background-color: var(--card-bg);
}

.configuracion-correos.dark-theme .form-control,
.configuracion-correos.dark-theme .form-select {
  background-color: rgba(15, 23, 42, 0.6);
  border-color: rgba(148, 163, 184, 0.3);
  color: var(--text-primary);
}

code {
  background: rgba(17, 115, 212, 0.08);
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 0.85em;
}
</style>
